const degreesToRadians = (degrees) => degrees * (Math.PI / 180);
export default degreesToRadians;
